// extracted by mini-css-extract-plugin
export default {"wrapper":"cookiesInfo_wrapper__l+rCB","logo":"cookiesInfo_logo__t4XGm","teamViewer":"cookiesInfo_teamViewer__naCUQ","itemWrapper":"cookiesInfo_itemWrapper__kcznW"};